/* Crimson Dawn — product thumbnail strip: native swipe + endless loop.
   On phones the theme hands this strip to Slick, which jumps three photos
   at a time and dead-ends at both edges. We hand it back so the strip
   scrolls natively (proper momentum swipe), then place a copy of the
   photos on either side and wrap the scroll position, so it circles
   forever in both directions.

   Cosmetic only: the hero-swap click handler the theme binds to each
   thumbnail is reused as-is, and on desktop nothing here runs. */
(function () {
  var MOBILE = '(max-width: 749px)';

  function strip() {
    return document.querySelector('ul.product-single__thumbnails');
  }

  function teardown(ul) {
    if (!ul || !ul.dataset.cdLoop) return;
    Array.prototype.forEach.call(ul.querySelectorAll('[data-cd-dup]'), function (n) {
      n.parentNode.removeChild(n);
    });
    ul.removeAttribute('data-cd-loop');
    ul.classList.remove('cd-loop');
  }

  function build() {
    var ul = strip();
    if (!ul) return;

    if (!window.matchMedia(MOBILE).matches) { teardown(ul); return; }

    /* take the strip back from Slick — the theme only runs it on mobile,
       and its own code no-ops safely once the slider is gone */
    var jq = window.jQuery;
    if (jq && ul.classList.contains('slick-initialized')) {
      try { jq(ul).slick('unslick'); } catch (e) { return; }
    }
    if (ul.dataset.cdLoop) return;

    var items = Array.prototype.filter.call(ul.children, function (li) {
      return li.classList.contains('product-single__thumbnails-item');
    });
    if (items.length < 4) return;          /* fits on screen; nothing to loop */

    ul.dataset.cdLoop = '1';
    ul.classList.add('cd-loop');

    function addCopies(where) {
      var frag = document.createDocumentFragment();
      items.forEach(function (li) {
        var copy = li.cloneNode(true);
        copy.setAttribute('data-cd-dup', '1');
        copy.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(copy.querySelectorAll('a'), function (a) {
          a.tabIndex = -1;
        });
        frag.appendChild(copy);
      });
      if (where === 'before') ul.insertBefore(frag, ul.firstChild);
      else ul.appendChild(frag);
    }
    addCopies('before');
    addCopies('after');

    var all = ul.querySelectorAll('.product-single__thumbnails-item');
    var count = items.length;
    /* exact width of one set, gaps included */
    function measure() {
      return all[count].offsetLeft - all[0].offsetLeft;
    }
    var setW = measure();
    if (!setW) { teardown(ul); return; }

    function toStart() { ul.scrollLeft = setW; }   /* sit on the real photos */
    toStart();
    /* thumbnails load lazily, so widths — and with them the start point —
       settle a moment after the strip is built */
    [100, 400, 1200].forEach(function (wait) {
      setTimeout(function () {
        var w = measure();
        if (w) setW = w;
        if (ul.scrollLeft === 0) toStart();
      }, wait);
    });

    var adjusting = false;
    ul.addEventListener('scroll', function () {
      if (adjusting) return;
      var x = ul.scrollLeft;
      /* hop to the identical spot in the middle set once the reader has
         drifted half a set into either copy — the photos either side are
         the same, so the jump is invisible and the strip never ends */
      var to = null;
      if (x < setW * 0.5) to = x + setW;
      else if (x > setW * 2.5) to = x - setW;
      if (to === null) return;
      adjusting = true;
      ul.scrollLeft = to;
      adjusting = false;
    }, { passive: true });

    /* copies carry the markup but not the theme's click handler, so pass
       the tap through to the real thumbnail */
    ul.addEventListener('click', function (e) {
      var dup = e.target.closest ? e.target.closest('[data-cd-dup]') : null;
      if (!dup) return;
      e.preventDefault();
      var link = dup.querySelector('.product-single__thumbnail');
      var id = link && link.getAttribute('data-thumbnail-id');
      if (!id) return;
      var real = ul.querySelector(
        '.product-single__thumbnails-item:not([data-cd-dup]) ' +
        '.product-single__thumbnail[data-thumbnail-id="' + id + '"]'
      );
      if (real) real.click();
    });
  }

  function init() {
    build();

    /* the theme creates/destroys its slider when the breakpoint changes,
       so re-evaluate on rotation/resize (build() removes the copies again
       whenever we are no longer on a phone) */
    var settle;
    window.addEventListener('resize', function () {
      clearTimeout(settle);
      settle = setTimeout(build, 300);
    });

    /* …and it initialises that slider after its own scripts have run */
    var tries = 0;
    var poll = setInterval(function () {
      var ul = strip();
      if (ul && ul.classList.contains('slick-initialized')) build();
      if (++tries > 20) clearInterval(poll);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
